import {
  isThirdParty,
  isPostCodeRegistration,
  setGhomeState,
} from 'services/utils/common'
import { getQueryParameter } from 'services/utils/strings'
import { GHS_URL, GEORGE_URL, DOT_COM_URL, BABY_CLUB_URL } from 'services/utils/constants/site-urls'
import { checkClientIdWithOrigin } from 'services/utils/third-party'
import { SET_REDIRECT_URI, TOGGLE_ACTION_PENDING } from '../actions/constants'

export const getRequestOrigin = (requestOrigin = getQueryParameter('request_origin') || 'asda') => {
  if (requestOrigin === 'george_intl') return 'george'
  return requestOrigin
}

const redirectUriFallback = (requestOrigin) => {
  if (requestOrigin === 'george') return GEORGE_URL
  if (requestOrigin === 'asda') return DOT_COM_URL
  if (requestOrigin === 'btc') return BABY_CLUB_URL
  if (requestOrigin === 'gi') return GHS_URL
  return DOT_COM_URL
}
const getFormattedRedirectUri = (url) => {
  if (!url) return false
  const urlRegEx = /^(?:https?:)?[^\s:]+$/
  return (urlRegEx.test(url) ? decodeURIComponent(url) : redirectUriFallback(getRequestOrigin()))
}
const initialState = {
  redirectUri: getFormattedRedirectUri(getQueryParameter('redirect_uri') || redirectUriFallback(getRequestOrigin())),
  requestOrigin: getRequestOrigin(),
  isFetching: false,
  isThirdParty: isThirdParty(),
  clientId: getQueryParameter('client_id') || '',
  userPostcode: (getQueryParameter('postcode') || '').toUpperCase(),
  postcodeRegistration: isPostCodeRegistration(),
  gHomeState: setGhomeState(),
  isGeorgeUser: getRequestOrigin() === 'george',
  isGroceryUser: getRequestOrigin() === 'gi',
  isDotComUser: getRequestOrigin() === 'asda',
  isBabyClubUser: getRequestOrigin() === 'btc',
  isGiftCardUser: checkClientIdWithOrigin('giftcards', getQueryParameter('client_id')) || getRequestOrigin() === 'giftcards',
  isChatBotUser: getRequestOrigin() === 'chatbot',
  isCreditCardUser: getRequestOrigin() === 'creditcard',
  isSSOMobileUser: getRequestOrigin() ==='ssomobile'
}
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_REDIRECT_URI:
      return { ...state }
    case TOGGLE_ACTION_PENDING:
      return {
        ...state,
        isFetching: action.isFetching,
      }
    default:
      return state
  }
}
